import React from 'react';

interface PortfolioSummaryProps {
  walletTotalTokens: number;
  walletTotalValue: number;
  selectedTokensCount: number;
  receivedTotal: number;
  isLoading: boolean;
}

export const PortfolioSummary: React.FC<PortfolioSummaryProps> = ({
  walletTotalTokens,
  walletTotalValue,
  selectedTokensCount,
  receivedTotal,
  isLoading,
}) => {
  return (
    <div className="bg-gray-800 rounded-lg p-4 sm:p-5 md:p-6">
      <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Portfolio Summary</h2>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3 md:gap-4">
        <div className="bg-gray-700 rounded-lg p-3 sm:p-4">
          <h3 className="text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2">Wallet Tokens</h3>
          <p className="text-lg sm:text-xl md:text-2xl font-bold text-white break-words">{walletTotalTokens}</p>
        </div>
        <div className="bg-gray-700 rounded-lg p-3 sm:p-4">
          <h3 className="text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2">Wallet Value</h3>
          <p className="text-lg sm:text-xl md:text-2xl font-bold text-green-400 break-words">
            ${walletTotalValue.toFixed(2)}
          </p>
        </div>
        <div className="bg-gray-700 rounded-lg p-3 sm:p-4">
          <h3 className="text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2">Selected Tokens</h3>
          <p className="text-lg sm:text-xl md:text-2xl font-bold text-yellow-400 break-words">{selectedTokensCount}</p>
        </div>
        <div className="bg-gray-700 rounded-lg p-3 sm:p-4">
          <h3 className="text-xs sm:text-sm text-gray-400 mb-1 sm:mb-2">Received</h3>
          <p className="text-lg sm:text-xl md:text-2xl font-bold text-blue-400 break-words">
            ${receivedTotal.toFixed(2)}
          </p>
        </div>
      </div>

      {/* Loading State */}
      {isLoading && (
        <div className="mt-3 sm:mt-4 p-3 sm:p-4 bg-gray-700 rounded-lg">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="animate-spin rounded-full h-4 w-4 sm:h-5 sm:w-5 border-b-2 border-green-400 flex-shrink-0"></div>
            <span className="text-sm  text-gray-300">Processing transactions...</span>
          </div>
        </div>
      )}
    </div>
  );
};

